export const pdlRegex = /^[0-9]{14}$/;
export const emailRegex = /^[\w-.]+[+]?[\w-.]+@([\w-]+\.)+[\w-]{2,}$/;
//TODO : impelment phoneRegex when phoneNUmber component is update
export const phoneRegex = /^(0|\+33\s?|33\s?)?[1-9](\s?\d){8}$/;
export const siretRegex = /^\d{3} ?\d{3} ?\d{3} ?\d{5}$/;
export const bicRegex = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/;
export const passwordRegex =
  /^((?=.*[a-z])(?=.*[A-Z])(?=.*\d)|(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])|(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9])|(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]))([A-Za-z\d@#$%^&amp;*\-_+=[\]{}|\\:',?/`~&quot;();!]|\.(?!@)){8,16}$/;
export const firstNameRegex = /^[a-zA-ZÀ-ÿ]([a-zA-ZÀ-ÿ- ]*[a-zA-ZÀ-ÿ])?$/;
export const lastNameRegex = /^[a-zA-ZÀ-ÿ]([a-zA-ZÀ-ÿ- ]*[a-zA-ZÀ-ÿ])?$/;
export const codeNafRegex = /^[0-9]{4}[A-Z]$/;
